<template>
    <div 
      class="fill-height">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
  
          <v-dialog v-model="dialog.freeze"
            @keydown.esc="dialog.freeze = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Freeze Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div 
                          class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in configHeaders" 
                              :key="index"
                              class="px-0"
                              @click="item.freeze = !item.freeze ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.freeze">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.freeze ? 'font-weight-bold' : ''"
                                  :style="item.freeze ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Freeze
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.hide"
            @keydown.esc="dialog.hide = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Hide Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.hide = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in headers" 
                              :key="index"
                              class="px-0"
                              @click="item.hide = !item.hide ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.hide">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.hide ? 'font-weight-bold' : ''"
                                  :style="item.hide ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Hide
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.filter"
            @keydown.esc="dialog.filter = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Filter Data
                </div>
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.filter = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <div>
                  <div class="body-2 mb-2">
                    Periode
                  </div>
  
                  <v-select
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Contoh. 2023"
  
                    :items="years"
                    :item-color="set_color"
  
                    v-model="filter.year"
                    style="border-radius: 10px;">
                  </v-select>
                </div>
  
                <div>
                  <div class="body-2 mb-2">
                    Bulan
                  </div>
  
                  <v-select
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Contoh. Januari"
  
                    :items="months"
                    item-text="text"
                    item-value="value"
                    :item-color="set_color"
  
                    v-model="filter.month"
                    style="border-radius: 10px;">
                  </v-select>
                </div>
  
                <div v-if="(new Date(filter.year, filter.month - 1, 1) < new Date(new Date(dpa.perubahan_date).getFullYear(), new Date(dpa.perubahan_date).getMonth(), 1))">
                  <div class="body-2 mb-2">
                    Status Anggaran
                  </div>
                  <div>
                    <v-autocomplete
                      filled
                      rounded
                      dense
  
                      :color="set_color"
                      placeholder="Pilih DPA"
  
                      :items="['murni', 'p1']"
                      :item-color="set_color"
                      clearable
                      @click:clear="filter.dpa = ''"
  
                      v-model="filter.dpa"
                      required
                      class="mx-1"
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </div>
                </div>
  
                <div>
                  <div class="body-2 mb-2">
                    Pengecualian
                  </div>
  
                  <v-select
                    filled
                    rounded
                    dense
  
                    :color="set_color"
                    placeholder="Pengecualian"
  
                    :items="[
                      { text: 'Dengan Pengecualian', value: '1' },
                      { text: 'Tanpa Pengecualian', value: '0' }
                    ]"
                    item-text="text"
                    item-value="value"
                    :item-color="set_color"
  
                    v-model="filter.is_pengecualian"
                    style="border-radius: 10px;">
                  </v-select>
                </div>
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn 
                  @click="dialog.filter = false; fetch();"
                  width="120"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Filter
                </v-btn>
  
                <v-btn 
                  @click="dialog.filter = false"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <section>
            <v-row
              class="pa-4 pb-2 pr-1">
              <v-col
                cols="12">
                <v-card
                  flat
                  color="transparent">
                  <div
                    class="d-flex align-center">
                    <div
                      class="d-flex align-center">
                      <v-avatar
                        tile
                        size="30">
                        <v-img
                          contain
                          alt="kominfoklaten"  
                          :src="require('@/assets/image/grip_menu.png')">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
  
                      <span
                        class="title black--text ml-2"
                        style="font-weight: 600;">
                        Perkembangan Fisik & Keuangan Bulanan Publik
                      </span>
                    </div>
  
                    <v-spacer />
  
                    <div>
                      
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              align="center"
              justify="end"
              class="pa-4 py-0 pr-1">
              <v-col
                cols="12"
                md="7">
                <div
                  class="body-2">
                  Periode 
  
                  <span v-if="filter.year !== '' && filter.year !== null">
                    tahun <strong class="black--text">{{ filter.year }}</strong>
                  </span>
  
                  <span v-if="filter.month !== '' && filter.month !== null">
                    bulan <strong class="black--text">{{ filter.month_text }}</strong>
                  </span>
  
                  <span v-if="filter.unit_id !== '' && filter.unit_id !== null">
                    di unit <strong class="black--text">{{ filter.unit_title }}</strong>
                  </span>
  
                  <span v-if="filter.is_pengecualian !== '' && filter.is_pengecualian !== null">
                    <strong class="black--text ml-1">{{ filter.is_pengecualian === '0' ? 'Tanpa Pengecualian' : 'Dengan Pengecualian' }}</strong>
                  </span>
                </div>
              </v-col>
  
              <v-col
                cols="12"
                md="5"
                class="d-flex align-center " style="justify-content: end;">
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="dialog.filter = true; fetchUnit();"
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon size="18">mdi-filter-multiple-outline</v-icon>
                      </v-btn>
                    </template>
  
                    <span>
                      Filter
                    </span>
                  </v-tooltip>
                </div>
  
                <!-- PRINT -->
                <!-- <div class="ml-3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="exportsExcel()"
                        :loading="process.exportExcel"
                        elevation="0"
                        dark
                        min-height="36"
                        small
                        min-width="36"
                        color="#216f45"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon size="18" color="white">mdi-microsoft-excel</v-icon>
                      </v-btn>
                    </template>
  
                    <span>
                      Export Excel
                    </span>
                  </v-tooltip>
                </div>
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="exports()"
                        :loading="process.export"
                        elevation="0"
                        dark
                        min-width="36"
                        color="#b40c1d"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon size="18">mdi-file-pdf-box</v-icon>
                      </v-btn>
                    </template>
  
                    <span>
                      Export Pdf
                    </span>
                  </v-tooltip>
                </div> -->
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4 pr-1">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
  
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
  
                  <div class="view" v-if="!process.load">
                    <div class="wrapper">
                      <table style="border: 1px solid #ededed;" class="table">
                        <tr>
                          <th rowspan="2" class="sticky-col one-col" style="font-size: 12px; z-index: 1; border: 1px solid #ededed;padding: 8px 12px; min-width: 350px; width: 350px; max-width: 350px;">Program, Kegiatan & Sub Kegiatan</th>
                          <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px">Nama PPKOM</th>
                          <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px">Nama PPTK</th>
                          <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: right;">Anggaran Murni</th>
                          <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: right;">Anggaran P1</th>
                          <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: right;">Anggaran Perubahan</th>
                          <th colspan="3" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: center;">Perkembangan Fisik</th>
                          <th colspan="4" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: center;">Perkembangan Keuangan</th>
                        </tr>
  
                        <tr>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 100px;">Realisasi %</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 100px;">Target %</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 100px;">Deviasi %</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px; text-align: right;">Anggaran Kas Perbulan ( Rp )</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Persentase SP2D terhadap Pagu Anggaran</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 220px; text-align: right;">Realisasi Keuangan/SP2D (Rp)</th>
                          <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Persentase SP2D terhadap Kas Perbulan</th>
                        </tr>
  
                        <tr v-for="(item, index) in list" :key="index">
                          <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                            <div :class="item.type === 'Program' ? 'font-weight-bold' : item.type === 'Kegiatan' ? '' : ''" :style="item.type === 'Kegiatan' ? 'font-weight: 600' : ''">
                              {{ item.title }}
                            </div>
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.type === 'Sub Kegiatan' ? item.ppkom_name : "" }}</td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.type === 'Sub Kegiatan' ? item.pptk_name : "" }}</td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.anggaran | price }}
                            </span>
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.anggaran_p1 | price }}
                            </span>
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.anggaran_perubahan | price }}
                            </span>
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? item.realisasi_fisik*1 < 1.00? 'background: red' : item.realisasi_fisik*1 === 100.00 ? '' : item.realisasi_fisik*1 <= 99.00 && item.realisasi_fisik*1 >= 76.00 ? 'background: blue' : item.realisasi_fisik*1 <= 75.00 && item.realisasi_fisik*1 >= 51.00 ? 'background: green' : item.realisasi_fisik*1 <= 50.00 && item.realisasi_fisik*1 >= 26.00 ? 'background: yellow' : item.realisasi_fisik*1 <=25.00 && item.realisasi_fisik*1 >=1.00 ? 'background: orange' : '' : ''"  style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.realisasi_fisik }}
                            </span>
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.target_fisik }}
                            </span>
                          </td>
                          <!-- <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.deviasi }}
                            </span>
                          </td> -->
                          <td :style="item.type === 'Sub Kegiatan' ? item.deviasi*1 <= -10? 'background: red' : item.deviasi*1 > 10 ? 'background: blue' : item.deviasi*1 <= 9.99 && item.deviasi*1 >= -2.99 ? 'background: green' : item.deviasi*1 <= -3.00 && item.deviasi*1 >= -5.99 ? 'background: yellow' : item.deviasi*1 <= -6.00 && item.deviasi*1 >= -9.99 ? 'background: orange' : '' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.deviasi }}
                            </span>
                            
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.target_keu | price }}
                            </span>
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.persentase_sp2d }}
                            </span>
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.realisasi_keu | price }}
                            </span>
                          </td>
                          <td :style="item.type === 'Sub Kegiatan' ? 'background: #01bcd512' : ''" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            <span v-if="item.type !== 'Sub Kegiatan'">
                              
                            </span>
                            <span v-else>
                              {{ item.persentase_sp2d_anggaran }}
                            </span>
                          </td>
                        </tr>
  
                        <tr v-if="Object.keys(detail).length > 0">
                          <td class="sticky-col one-col font-weight-bold text-center" style="font-size: 14px; border: 1px solid #ededed;padding: 8px 12px;">Jumlah</td>
                          <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;"></td>
                          <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;"></td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                            {{ detail.total_anggaran | price }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                            {{ detail.total_anggaran_p1 | price }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                            {{ detail.total_anggaran_perubahan | price }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            {{ detail.average_realisasi_fisik }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            {{ detail.average_target_fisik }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            {{ detail.total_deviasi }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                           Rp. {{ detail.total_target_keu }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            {{ detail.total_persentase_sp2d }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: right;">
                            
                            {{ detail.total_realisasi_keu }}
                            
                          </td>
                          <td class=" font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                            
                            {{ detail.total_persentase_sp2d_anggaran }}
                            
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import { TokenService } from "@/service/Storage.Service";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          checkbox: false,
  
          expanded_program: [],
          expanded_kegiatan: [],
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            filter: false
          },
          
          search: '',
          asistensi: [
  
          ],
  
          filter: {
            year: new Date().getFullYear(),
  
            month: 1,
            month_text: 'Januari',
  
            unit_id: '',
            unit_title: '',
            is_pengecualian: '1',
            dpa: 'murni'
          },
  
          filter_data: {
            unit: []
          },
  
          selected: {
            row_program: [],
            row_kegiatan: [],
            row_sub_kegiatan: [],
  
            freeze: [],
            delete: []
          },
  
          options: {},
          headers: [],
          list: [],
          detail: {},
          pagination: {},
  
          lastIndex: 0,
          limit: 20,
  
          process: {
            load: false,
  
            export: false,
            exportExcel: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
      },
      watch: {
        // '$route.query.unit': function(val) {
        //   this.filter.unit_id = val
        //   this.fetch()
        // },
        'options': {
          handler () {
            let pagination = { row: this.limit, page: 1 }
            
            this.fetch(pagination)
          },
          deep: true
        },
  
        'filter.year': function () {
          this.fetchDpa()
        },
  
        'filter.month': function () {
          let t = this
  
          let m = this.months.filter(function(v) {
            return t.filter.month == v.value
          })
  
          if (m.length > 0) {
            this.filter.month_text = m[0].text
          }
        },
  
        'filter.unit_id': function () {
          let t = this
  
          let u = this.filter_data.unit.filter(function(v) {
            return t.filter.unit_id == v.id
          })
  
          if (u.length > 0) {
            this.filter.unit_title = u[0].title
          }
        },
  
        '$store.state.unit_id': function(val) {
          this.filter.unit_id = val
          this.fetch()
        },
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        dpa () {
          return this.$store.state.dpa
        },
        user () {
          return this.$store.state.user
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
  
        years () {
          let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []
  
          this.filter.year = this.$store.state.year
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        },
        months () {
          let numb = new Date().getMonth() + 1
          
          // this.filter.month = numb
  
          // this.filter.month_text = new Date().toLocaleString('id', { month: 'long' })
  
          return [
            {
              text: 'Januari',
              value: 1
            },
            {
              text: 'Februari',
              value: 2
            },
            {
              text: 'Maret',
              value: 3
            },
            {
              text: 'April',
              value: 4
            },
            {
              text: 'Mei',
              value: 5
            },
            {
              text: 'Juni',
              value: 6
            },
            {
              text: 'Juli',
              value: 7
            },
            {
              text: 'Agustus',
              value: 8
            },
            {
              text: 'September',
              value: 9
            },
            {
              text: 'Oktober',
              value: 10
            },
            {
              text: 'November',
              value: 11
            },
            {
              text: 'Desember',
              value: 12
            }
          ]
        }
      },
      mounted () {
        this.fetchDpa()
        this.fetchUnit()
      },
      methods: {
        async fetchDpa () {
          let params = {
            tahun:  this.filter.year
          }
          await get('admin/dpa/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
  
              TokenService.saveDpa(JSON.stringify(res.results.data[0]))
  
              this.$store.commit("setDpa", res.results.data[0])
              
              if (this.$store.state.user.role === 'opd') {
                this.fetch()
              } else {
                // if(this.$route.query.unit !== undefined){
                  this.filter.unit_id = this.$store.state.unit_id === '' ? '501' : this.$store.state.unit_id
                // }
                this.fetch()
              }
              
            }
          })
        },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = Number(value)
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            let regex = /(<([^>]+)>)/ig
  
            data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = Number(value) + ' %'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
        rowClickProgram (item, row) {
          row.select(!row.isSelected ? true : false)
  
          this.expanded_program = []
  
          this.expanded_kegiatan = []
  
          this.selected.row_kegiatan = []
  
          this.selected.row_sub_kegiatan = []
  
          if (row.isExpanded) {
            const indexExpanded = this.expanded_program.findIndex(i => i === item)
            this.expanded_program.splice(indexExpanded, 1)
          } else {
            this.expanded_program.push(item)
          }
        },
        handleToggleAllProgram (event) {
          if (!event.value) this.selected.row_program = []
        },
  
        rowClickKegiatan (item, isExpanded) {
          this.toggleSelectionKegiatan(item.id)
  
          this.expanded_kegiatan = []
  
          this.selected.row_sub_kegiatan = []
  
          if (isExpanded) {
            const indexExpanded = this.expanded_kegiatan.findIndex(i => i === item)
            this.expanded_kegiatan.splice(indexExpanded, 1)
          } else {
            this.expanded_kegiatan.push(item)
          }
        },
        toggleSelectionKegiatan (keyID) {
          this.selected.row_kegiatan = []
          
          if (this.selected.row_kegiatan.includes(keyID)) {
            this.selected.row_kegiatan = this.selected.row_kegiatan.filter(selectedKeyID => selectedKeyID !== keyID)
          } else {
            this.selected.row_kegiatan.push(keyID)
          }
        },
  
        rowClickSubKegiatan (item) {
          this.toggleSelectionSubKegiatan(item.id)
        },
        toggleSelectionSubKegiatan (keyID) {
          this.selected.row_sub_kegiatan = []
          
          if (this.selected.row_sub_kegiatan.includes(keyID)) {
            this.selected.row_sub_kegiatan = this.selected.row_sub_kegiatan.filter(selectedKeyID => selectedKeyID !== keyID)
          } else {
            this.selected.row_sub_kegiatan.push(keyID)
          }
        },
  
        async fetch (pagination = { row: 20000000000000000000000, page: 1 }) {
          this.process.load = true
  
          console.log(this.dpa.perubahan_date, new Date(this.filter.year, this.filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1))
  
          this.limit = pagination.row
  
          let params = {
            limit: pagination.row,
            page: pagination.page,
            search: this.search,
  
            unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id,
  
            tahun_anggaran: this.filter.year,
  
            is_pengecualian: this.filter.is_pengecualian,
  
            year: this.filter.year,
            month: this.filter.month,
  
            dpa_status: new Date(this.filter.year, this.filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) ? this.filter.dpa : 'perubahan'
          }
  
          this.selected.row_program = []
  
          await get(`admin/report/fisik_dan_keu_dev_public`, { params })
          .then(response => {
            let res = response.data
  
            this.process.load = false
  
            this.list = []
            this.pagination = {}
              
            if (res.status === 200) {
              this.headers = [
                {
                  text: 'Aksi',
                  width: '80px',
                  value: 'id',
                  freeze: true,
                  hide: false,
                  align: 'center',
                  format: 'action'
                },
                {
                  text: 'Kode',
                  width: '200px',
                  value: 'code',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Judul',
                  width: '400px',
                  value: 'title',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'PPKOM',
                  width: '200px',
                  value: 'ppkom_name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'PPTK',
                  width: '200px',
                  value: 'pptk_name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Nominal Anggaran',
                  width: '200px',
                  value: 'anggaran',
                  freeze: false,
                  hide: false,
                  format: 'number',
                  align: 'end'
                },
                {
                  text: 'Tahun Anggaran',
                  width: '200px',
                  value: 'tahun_anggaran',
                  freeze: false,
                  hide: false,
                  align: 'center'
                },
                {
                  text: 'Target Fisik',
                  width: '200px',
                  value: 'target_fisik',
                  freeze: false,
                  hide: false,
                  format: 'percent',
                  align: 'center'
                },
                {
                  text: 'Target Keuangan',
                  width: '200px',
                  value: 'target_keu',
                  freeze: false,
                  hide: false,
                  format: 'number',
                  align: 'end'
                },
                {
                  text: 'Realisasi Fisik',
                  width: '200px',
                  value: 'realisasi_fisik',
                  freeze: false,
                  hide: false,
                  format: 'percent',
                  align: 'center'
                },
                {
                  text: 'Realisasi Keuangan',
                  width: '200px',
                  value: 'realisasi_keu',
                  freeze: false,
                  hide: false,
                  format: 'number',
                  align: 'end'
                },
                {
                  text: 'Deviasi',
                  width: '200px',
                  value: 'deviasi',
                  freeze: false,
                  hide: false,
                  align: 'center'
                },
                {
                  text: 'SP2D (%)',
                  width: '200px',
                  value: 'persentase_sp2d',
                  freeze: false,
                  hide: false,
                  format: 'percent',
                  align: 'center'
                },
                {
                  text: 'SP2D (Anggaran)',
                  width: '200px',
                  value: 'persentase_sp2d_anggaran',
                  freeze: false,
                  hide: false,
                  format: 'percent',
                  align: 'center'
                }
              ]
  
              // this.list = res.results.data
              // this.pagination = res.results.pagination
              res.results.data.map((item, index) => {
                item.deviasi = (item.deviasi).toFixed(2)
              })
              
              // this.list = res.results.data
              this.list = []
              res.results.data.map((v, i) => {
                if (v.par_id === '0') {
                  this.list.push(v)
                  res.results.data.map((v2, i2) => {
                    if (v2.par_id === v.id) {
                      this.list.push(v2)
                      res.results.data.map((v3, i3) => {
                        if (v3.par_id === v2.id) {
                          this.list.push(v3)
                        }
                      })
                    }
                  })
                }
              })
              this.detail = res.results
              this.pagination = {
                total_data: res.results.data.length,
                total_page: 1,
                total_display: res.results.data.length,
                first_page: false,
                last_page: false,
                prev: 0,
                current: 1,
                next: 0,
                detail: [],
                start: 1,
                end: 10
              }
  
              this.lastIndex = (pagination.page - 1) * pagination.row 
              this.lastIndex += 1
  
              this.addFreezes()
  
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
  
              if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },
  
        changeData (data_array) {
          function filter (array, condition) {
            let result = []
  
            for (let i = 0; i < array.length; i++) {
              if (condition(array[i])) {
                result.push(array[i])
              }
            }
  
            return result
          }
  
          function getChilds (parentKey, items) {
            let subItems = filter(items, function (n) {
              return n.par_id === parentKey
            })
  
            let result = []
  
            for (let i = 0; i < subItems.length; i++) {
              let subItem = subItems[i]
  
              let kids = getChilds(subItem.id, items)
              if (kids.length) {
                subItem.children = kids
              }
  
              result.push(subItem)
            }
  
            if (parentKey.length) {
              return result
            } else {
              return result[0]
            }
          }
  
          const data = data_array
  
          let richMediaData = getChilds('0', data)
  
          return richMediaData
        },
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = '#e0e0e0'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },
  
        // FILTER
        async fetchUnit () {
          let params = {
            limit: 100000,
            year: new Date().getFullYear()
          }
  
          await get('admin/unit/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.filter_data.unit = res.results.data
              // if (this.$route.query.unit !== undefined) {
                res.results.data.map(obj => {
                  if (obj.id === this.filter.unit_id) {
                    this.filter.unit_title = obj.title
                  }
                })
              // }
            }
          })
        },
  
        // EXPORT
        async exports () {
          this.message.error = ''
  
          this.process.export = true
  
          let params = {
            unit_id: this.filter.unit_id,
  
            tahun_anggaran: this.filter.year,
  
            is_pengecualian: this.filter.is_pengecualian,
  
            year: this.filter.year,
            month: this.filter.month,
            dpa_status: new Date(this.filter.year, this.filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) ? this.filter.dpa : 'perubahan'
          }
  
          await axios({
            url: `${process.env.VUE_APP_API_URL}/admin/report/export_fisik_dev_pdf`,
            method: 'GET',
            responseType: 'blob', // important,
            params: params,
            headers: {
              Authorization: process.env.VUE_APP_XAUTH,
              token: TokenService.getToken()
            }
          }).then((response) => {
            let res = response
            // console.log(res)
  
            this.process.export = false
            let disposition = res.headers['content-disposition']
            var fileName = res.headers['content-disposition'].split('filename=')[1]
            let filename = ''
            if (disposition && disposition.indexOf('inline') !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) { 
                filename = matches[1].replace(/['"]/g, '');
              }
            }
  
            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = 'Berhasil mengeksport pdf'
  
              const url = window.URL.createObjectURL(new Blob([response.data]))
              const link = document.createElement('a')
              link.href = url
  
              link.setAttribute('download', filename)
              document.body.appendChild(link)
  
              link.click()
            } else {
              this.message.error = res.message
            }
          })
        },
  
  
        async exportsExcel () {
          this.message.error = ''
  
          this.process.exportExcel = true
  
          let params = {
            unit_id: this.filter.unit_id,
  
            tahun_anggaran: this.filter.year,
  
            is_pengecualian: this.filter.is_pengecualian,
  
            year: this.filter.year,
            month: this.filter.month,
            dpa_status: new Date(this.filter.year, this.filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) ? this.filter.dpa : 'perubahan'
          }
  
          await axios({
            url: `${process.env.VUE_APP_API_URL}/admin/report/export_fisik_dev_excel`,
            method: 'GET',
            responseType: 'blob', // important,
            params: params,
            headers: {
              Authorization: process.env.VUE_APP_XAUTH,
              token: TokenService.getToken()
            }
          }).then((response) => {
            let res = response
            // console.log(res)
  
            this.process.exportExcel = false
            let disposition = res.headers['content-disposition']
            var fileName = res.headers['content-disposition'].split('filename=')[1]
  
            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = 'Berhasil mengeksport Excel'
  
              const url = window.URL.createObjectURL(new Blob([response.data]))
              const link = document.createElement('a')
              link.href = url
  
              link.setAttribute('download', fileName)
              document.body.appendChild(link)
  
              link.click()
            } else {
              this.message.error = res.message
            }
          })
        }
      }
    }
  </script>
  
  
  <style>
    table, th, td {
      /* border: 1px solid #ededed;
      border-collapse: collapse; */
      /* border: thin ridge black; */
      border-spacing: 4px;
      border-collapse: collapse;
    }
  
    .view {
      margin: auto;
      width: 100%;
    }
  
    .wrapper {
      /* position: relative;
      overflow: auto;
      white-space: nowrap; */
    }
  
    .wrapper th {
        /* background: #04a8bf5e; */
    }
  
    .wrapper { 
      overflow-y: auto; 
      height: calc(100vh - 260px); 
    } 
    .wrapper th { 
      position: sticky; 
      top: 0; 
      background-color: white !important;
    } 
  
    .sticky-col {
      position: -webkit-sticky;
      position: sticky;
      background-color: white !important;
    }
  
    .one-col {
      width: 350px;
      min-width: 350px;
      max-width: 350px;
      left: 0px;
    }
  
    .second-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 150px;
    }
  
    .three-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 300px;
    }
  
    .four-col {
      width: 200px;
      min-width: 200px;
      max-width: 200px;
      left: 450px;
    }
    </style>